import filterHeaderTitleUrl from './filterHeaderTitle.html';
export default {
  templateUrl: filterHeaderTitleUrl,
  controllerAs: 'ctrl',
  controller: class {
    constructor(Utils) {
      'ngInject';

      Object.assign(this, { Utils });
    }

    $onInit() {
      if (this.pluralizeName === undefined) {
        this.pluralizeName = true;
      }

      this.filterNameSingular = this.Utils.splitCamelCase(this.filterName).join(' ');
      this.filterNamePlural = this.pluralizeName
        ? `${this.filterNameSingular}${this.filterNameSingular.endsWith('s') ? 'es' : 's'}`
        : this.filterNameSingular;
    }
  },
  bindings: {
    customClassName: '@?',
    filterName: '@',
    filterKey: '@?',
    clearFilters: '&',
    clearLabel: '@?',
    titlePrefix: '@?',
    filterLength: '=',
    allLabel: '=?',
    pluralizeName: '<?',
  },
};
